<template>
	<v-dialog v-model="loadingStatus" hide-overlay persistent width="300">
		<v-card class="loader-card" elevation="8" rounded="xl">
			<v-card-text class="d-flex align-center pa-5">
				<div class="loader-icon mr-4">
					<v-icon color="white" size="22">mdi-dumbbell</v-icon>
				</div>
				<div class="loader-body">
					<p class="loader-label">Chargement en cours...</p>
					<v-progress-linear
						indeterminate
						color="#c62828"
						background-color="#fce4e4"
						rounded
						height="5"
						class="mt-2"
					></v-progress-linear>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "Loader",
	props: ["dialog"],
	computed: {
		loadingStatus() {
			return this.dialog === true;
		},
	},
};
</script>

<style scoped>
.loader-card {
	font-family: Montserrat, sans-serif;
}
.loader-icon {
	width: 42px;
	height: 42px;
	border-radius: 12px;
	background: linear-gradient(135deg, #c62828, #1565c0);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.loader-body {
	flex: 1;
}
.loader-label {
	font-size: 0.82rem;
	font-weight: 600;
	color: #374151;
	margin: 0;
}
</style>
